import * as React from 'react'

import { DOMRef, DetailProps, ScopedCSSRules } from '@dna/react-types'
import { css, cx, detailStyles } from '@dna/core'

import { filterDOMProps, fontStyleProps, useStyleProps } from '../utils'

function Detail(props: DetailProps, ref: DOMRef<HTMLElement>) {
  let {
    UNSAFE_className,
    UNSAFE_style,
    as: ElementType = 'span',
    children,
    css: styleProps = {},
    level = 'medium',
    ...otherProps
  } = props
  let {
    styleProps: { className, style },
  } = useStyleProps(
    { ...styleProps, UNSAFE_className, UNSAFE_style },
    fontStyleProps
  )
  let styles = detailStyles({ level })

  return (
    <ElementType
      {...filterDOMProps(otherProps)}
      className={cx(
        css(styles as ScopedCSSRules),
        css(style as ScopedCSSRules),
        className
      )}
      ref={ref}
    >
      {children}
    </ElementType>
  )
}

/**
 * Detail is a typography component used for disclosing extra information or smaller items in hierarchical relationships of text.
 *
 * @name
 * Detail
 *
 * @see
 * https://dna.telstrahealth.com/components/detail/
 *
 * @example
 * <Detail level="small">Hello there!</Detail>
 * */
let _Detail = React.forwardRef(Detail)
export { _Detail as Detail }
